function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.75 7H7c-2.76 0-5 2.24-5 5v5c0 2.76 2.24 5 5 5h5c2.76 0 5-2.24 5-5v-4.75C17 9.35 14.65 7 11.75 7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.88 6.33c.524 2.56-.718 4.882-2.721 5.976-.308.168-.66-.072-.66-.423v-.133c0-3.44-2.81-6.25-6.25-6.25h-.133c-.35 0-.59-.352-.422-.66 1.094-2.002 3.416-3.245 5.976-2.72 2.09.43 3.78 2.12 4.21 4.21z"
})));